// import library
import { library } from "@fortawesome/fontawesome-svg-core";

// import icons
import { faArrowDown, faFire, faInfinity, faDragon, faCaretRight } from "@fortawesome/free-solid-svg-icons";

// add icon library
library.add(faArrowDown, faFire, faInfinity, faDragon, faCaretRight);
